import React from 'react'
import { Button, TextField, makeStyles } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const TimeInput = ({
  className,
  disabled = false,
  hours = '00',
  minutes = '00',
  onChange,
  selectedOption = 'AM',
  title = 'Time',
}) => {
  const handleHoursBlur = () => {
    if (hours.length === 1) {
      onChange({
        hours: `0${hours}`,
        minutes: minutes ? minutes : '00',
        selectedOption,
      })
    }
  }

  const handleMinutesBlur = () => {
    if (minutes.length === 1) {
      onChange({
        hours: hours ? hours : '12',
        minutes: `0${minutes}`,
        selectedOption,
      })
    }
  }

  const handleHoursKeyUp = event => {
    if (event.key === 'ArrowUp') {
      let newHours = parseInt(hours || 0, 10) + 1
      let newOption = selectedOption
      if (newHours === 12) {
        newOption = selectedOption === 'AM' ? 'PM' : 'AM'
      } else if (newHours === 13) {
        newHours = 1
      }

      onChange({
        hours: newHours < 10 ? `0${newHours}` : newHours.toString(),
        minutes: minutes ? minutes : '00',
        selectedOption: newOption,
      })
    } else if (event.key === 'ArrowDown') {
      let newHours = parseInt(hours || 0, 10) - 1
      let newOption = selectedOption
      if (newHours <= 0) {
        newHours = 12
      } else if (newHours === 11) {
        newOption = selectedOption === 'AM' ? 'PM' : 'AM'
      }

      onChange({
        hours: newHours < 10 ? `0${newHours}` : newHours.toString(),
        minutes: minutes ? minutes : '00',
        selectedOption: newOption,
      })
    }
  }

  const handleMinutesKeyUp = event => {
    if (event.key === 'ArrowUp') {
      let newMinutes = parseInt(minutes || 0, 10) + 1
      if (newMinutes > 59) {
        newMinutes = 0
      }

      onChange({
        hours: hours ? hours : '12',
        minutes: newMinutes < 10 ? `0${newMinutes}` : newMinutes.toString(),
        selectedOption,
      })
    } else if (event.key === 'ArrowDown') {
      let newMinutes = parseInt(minutes || 0, 10) - 1
      if (newMinutes < 0) {
        newMinutes = 59
      }

      onChange({
        hours: hours ? hours : '12',
        minutes: newMinutes < 10 ? `0${newMinutes}` : newMinutes.toString(),
        selectedOption,
      })
    }
  }

  const handleHoursChange = event => {
    const value = event.target.value
    if (value === '' || (value >= 0 && value <= 12)) {
      onChange({
        hours: value,
        minutes: minutes ? minutes : '00',
        selectedOption,
      })
    }
  }

  const handleMinutesChange = event => {
    const value = event.target.value
    if (value === '' || (value >= 0 && value <= 59)) {
      onChange({ hours: hours ? hours : '12', minutes: value, selectedOption })
    }
  }

  const handleSelectedOption = option => {
    onChange({ hours, minutes, selectedOption: option })
  }

  const classes = useStyles()

  return (
    <div className={`${className ? className : ''} ${classes.container}`}>
      <span className={classes.datePickerHeaderTitle}>{title}</span>
      <div className={classes.timeContainer}>
        <TextField
          className={[classes.input, classes.hoursInput]}
          variant="standard"
          value={hours}
          onChange={handleHoursChange}
          onBlur={handleHoursBlur}
          onKeyUp={handleHoursKeyUp}
          placeholder={'hh'}
          inputProps={{ maxLength: 2 }}
          disabled={disabled}
        />
        <span className={classes.dots}>:</span>
        <TextField
          className={[classes.input, classes.minutesInput]}
          variant="standard"
          value={minutes}
          onChange={handleMinutesChange}
          onBlur={handleMinutesBlur}
          onKeyUp={handleMinutesKeyUp}
          placeholder={'mm'}
          inputProps={{ maxLength: 2 }}
          disabled={disabled}
        />
      </div>
      <div className={classes.optionsContainer}>
        <Button
          variant={selectedOption === 'AM' ? 'contained' : 'outlined'}
          color={selectedOption === 'AM' ? 'primary' : 'default'}
          onClick={() => handleSelectedOption('AM')}
          style={{ borderRadius: 0 }}
          disabled={disabled}
        >
          AM
        </Button>
        <Button
          variant={selectedOption === 'PM' ? 'contained' : 'outlined'}
          color={selectedOption === 'PM' ? 'primary' : 'default'}
          onClick={() => handleSelectedOption('PM')}
          style={{ borderRadius: 0, borderLeft: '1px solid grey' }}
          disabled={disabled}
        >
          PM
        </Button>
      </div>
    </div>
  )
}

export { TimeInput }
